import { getServerTime } from "@/lib/appwrite";

export async function getEcuadorServerDate(): Promise<Date> {
  const execution = await getServerTime();
  const responseBody = execution.responseBody;

  if (!responseBody) throw new Error("No se recibió la hora del servidor");

  const data = JSON.parse(responseBody); 
  return new Date(data.timestamp);
}
